export var defaultProps = {
    className: '',
    defaultValue: undefined,
    value: undefined,
    data: [],
    placeholder: '',
    rightIcon: null,
    onChange: function (value, selectOptions) { },
    onBeforeChange: function (value, selectOptions) { return true; },
    onSelectEnd: function () { },
    loadData: function (selectOption) { },
};
